export const INGREDIENT_SECTORS = ["Cocina", "Barra"];

export const BASE_UNIT_LABELS = {
  g: "Gramos (g)",
  ml: "Mililitros (ml)",
  unit: "Unidad",
  package: "Paquete",
};

export function normalizeIngredientSectors(value) {
  const values = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split(",")
      : [];

  return INGREDIENT_SECTORS.filter((sector) =>
    values.some(
      (item) =>
        String(item).trim().toLocaleLowerCase("es-AR") ===
        sector.toLocaleLowerCase("es-AR")
    )
  );
}

export function formatIngredientSectors(value) {
  const sectors = normalizeIngredientSectors(value);
  return sectors.length ? sectors.join(" y ") : "-";
}

export function formatYield(value) {
  if (value === null || value === undefined || value === "") return "-";

  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return String(value);

  return `${(numberValue * 100).toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })}%`;
}

export function formatYieldInput(value) {
  if (value === null || value === undefined || value === "") return "";

  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return String(value);

  return (numberValue * 100).toLocaleString("es-AR", {
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function normalizeYieldInput(value) {
  return String(value ?? "").replace(/\./g, ",");
}

export function parseYieldPercentage(value) {
  const normalized = String(value ?? "").trim().replace(",", ".");
  if (!normalized) return null;
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return undefined;

  const percentage = Number(normalized);
  const factor = percentage / 100;
  if (!Number.isFinite(factor) || percentage > 100) return undefined;

  return Number(factor.toFixed(4));
}

export function formatBaseUnit(value) {
  return BASE_UNIT_LABELS[value] || value || "-";
}

export function normalizeIngredientRow(ingredient) {
  if (!ingredient) return null;

  const sector = normalizeIngredientSectors(ingredient.sector);

  return {
    ...ingredient,
    category: ingredient.category || "-",
    name: ingredient.name || "-",
    sector,
    sectorLabel: formatIngredientSectors(sector),
    baseUnitLabel: formatBaseUnit(ingredient.baseUnit),
    yieldLabel: formatYield(ingredient.defaultYieldFactor),
    isActive: Boolean(ingredient.isActive),
    isStockActive: Boolean(ingredient.isStockActive),
  };
}
